module.exports = __webpack_public_path__ + "static/media/p208g2.184d48b0.jpg";